export default "__VITE_ASSET__C9sEIiE___"